module.exports = __webpack_public_path__ + "img/1.941a1e1f.jpg";